<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      :picker-options="pickerOptions2" value-format="yyyyMMdd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-input prefix-icon="el-icon-search" placeholder="输入房间号查询" v-model="searchKeyword" style="width: 300px"></el-input>
      <el-select v-fixZoom v-model="sendType" placeholder="状态" style="width: 100px">
        <el-option v-for="item in typeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="getSearchData()">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="编号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="机构名称"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="检查项目"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="楼栋"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="楼层"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="房间号"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="参加人员"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="查房时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="提交时间"
          min-width="100"
          align="center">
        </el-table-column>
<!--        <el-table-column align="center" label="操作" width="150">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button size="mini" type="primary">记录表</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'roomStatistics',
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      sendDate: [],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      searchKeyword: '',
      typeArr: [{id: 0, name: '夜间巡查'}, {id: 1, name: '卫生情况'}],
      sendType: ''
    }
  },
  created () {
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyyMMdd')
    this.sendDate = [date, date]
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + arr[1] + '01'
        obj.end = arr[0] + arr[1] + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
    },
    getSearchData () {},
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/roomStatistics.vue